import { render, staticRenderFns } from "./XiYouKeywordRank.vue?vue&type=template&id=3bf62dc3"
import script from "./XiYouKeywordRank.vue?vue&type=script&lang=js"
export * from "./XiYouKeywordRank.vue?vue&type=script&lang=js"
import style0 from "./XiYouKeywordRank.vue?vue&type=style&index=0&id=3bf62dc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports